module.exports = __webpack_public_path__ + "static/media/40.b4b039ec.png";